import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '../../../../../core/services/payment.service';
import { UserService } from '../../../../../core/services/user.service';

@Component({
  selector: 'app-payment-complete',
  templateUrl: './payment-complete.component.html',
  styleUrls: ['./payment-complete.component.scss']
})
export class PaymentCompleteComponent implements OnInit {
  trackerId: string;
  confirmatioNumber: string;
  constructor(private paymentService: PaymentService,
    private router: Router,
    private userService: UserService,
    private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParamMap.subscribe(params => {
      console.log(params);
      this.trackerId = params.get('trackerID') || '';
      this.confirmatioNumber = params.get('Confirmation Number') || '';
      console.log(params);
      console.log("completion trackerid=" + this.trackerId);
    }
    );
  }

  async ngOnInit() {
    //if (!this.userService.hasAccessToMakeInvoicePayment()) {
    //  this.router.navigate(['invoice-inquiry']);
    //}
    if (this.trackerId && this.trackerId.length > 0) {
      try {
        await this.paymentService.completeLastTransaction(this.trackerId, this.confirmatioNumber).toPromise();
      } catch (e) { }
      //}
    }
    this.router.navigate(['/invoice-inquiry/payment/review']);

  }
}
